<template>
  <div>
    <wc-data-box
      title='Quote Email'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='editDeliberable'
      showHelp
      helpText='This is the email message that will be sent to the customer, along with the attached PDF quote'
    >
      <v-card-text>
        <span v-html='estimate.deliverable'></span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      title='Quote Preview'
      :showDialog='showPreview'
      :icon='icon'
      :iconColor='iconColor'
      @save='showPreview = false'
      hideCancel
      saveText='Close'
      width='700'
    >
      <deliverable-preview
        :estimate='showEdit ? estimateCopy : estimate'
        :lines='estimateLines'
        :options='options'
        :isTemplate='isTemplate'
      >
      </deliverable-preview>
    </wc-dialog>

    <wc-dialog
      :showDialog='showEdit'
      title='Edit Quote Email'
      :icon='icon'
      ignoreEnter
      @cancel='showEdit = false'
      @save='saveDeliverables'
    >
      <vue-editor :editor-toolbar='customToolbar' v-model='estimateCopy.deliverable'></vue-editor>
    </wc-dialog>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import _ from 'lodash'
import DeliverablePreview from '@/modules/estimates/components/DeliverablePreview'
import estimateLineItems from '@/modules/estimates/api/estimateLineItems'

export default {
  name: 'estimate-deliverable',
  props: {
    estimate: {
      required: true
    },
    isTemplate: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: true,
    showEdit: false,
    showPreview: false,
    icon: 'mdi-email-outline',
    previewIcon: 'mdi-file-find-outline',
    iconColor: 'success',
    estimateCopy: [],
    customToolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }]
    ],
    estimateLines: [],
    options: null
  }),
  methods: {
    editDeliberable () {
      this.estimateCopy = _.cloneDeep(this.estimate)
      this.showEdit = true
    },
    saveDeliverables () {
      this.isLoading = true
      this.$emit('update', this.estimateCopy)
      this.showEdit = false
      this.isLoading = false
    },
    async openPreview () {
      this.isLoading = true
      this.estimateLines = await estimateLineItems.getEstimateLineItems(this.estimate.id)
      this.options = await estimateLineItems.getOptionalLineItems(this.estimate.id)
      this.showPreview = true
    }
  },
  components: {
    'vue-editor': VueEditor,
    'deliverable-preview': DeliverablePreview
  }
}
</script>
